import { render, staticRenderFns } from "./AppButtonBordeless.vue?vue&type=template&id=2ee1f290&scoped=true&"
import script from "./AppButtonBordeless.vue?vue&type=script&lang=ts&"
export * from "./AppButtonBordeless.vue?vue&type=script&lang=ts&"
import style0 from "./AppButtonBordeless.vue?vue&type=style&index=0&id=2ee1f290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee1f290",
  null
  
)

export default component.exports